import {EDIT_ERROR_STARTED} from "../../../reducers/editErrorReducer";


export const editErrorStarted = () =>{
    return {
        type: EDIT_ERROR_STARTED,
        payload: {}
    }
}